import { colors } from '../lib/theme';

const FEATURES = [
  {
    title: 'Shopping list',
    description: 'Auto-generated from everything you log this week, grouped and deduped by product.',
    color: colors.blue,
    textColor: colors.blueText,
  },
  {
    title: 'Daily kcal limit',
    description: 'Set a daily calorie target on the Meal screen and get a warning when a day runs over it.',
    color: colors.mint,
    textColor: colors.mintText,
  },
  {
    title: 'Theme color customization',
    description: 'Pick your own accent palette instead of the default pastel theme.',
    color: colors.peach,
    textColor: colors.peachText,
  },
  {
    title: 'Auto-generate dishes with AI',
    description: 'Describe what you like to eat and let AI draft new dishes — tags, macros, and all — ready to add to your Menu.',
    color: colors.lavender,
    textColor: colors.lavenderText,
  },
];

export default function Upgrade() {
  return (
    <div>
      <h2>Upgrade to PRO</h2>
      <p style={{ opacity: 0.75, maxWidth: 480 }}>
        PRO unlocks a couple of extra planning tools on top of everything in the free Base tier.
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', margin: '1.5rem 0', maxWidth: 480 }}>
        {FEATURES.map((feature) => (
          <div
            key={feature.title}
            style={{
              background: feature.color,
              color: feature.textColor,
              borderRadius: 14,
              padding: '0.9rem 1.1rem',
            }}
          >
            <div style={{ fontWeight: 700 }}>{feature.title}</div>
            <div style={{ fontSize: '0.9rem', opacity: 0.85, marginTop: '0.25rem' }}>{feature.description}</div>
          </div>
        ))}
      </div>

      <button
        disabled
        style={{
          background: '#e0ddd7',
          color: '#8a8578',
          border: 'none',
          borderRadius: 999,
          padding: '0.6rem 1.3rem',
          fontWeight: 700,
          cursor: 'not-allowed',
        }}
      >
        Upgrade — Coming soon
      </button>
    </div>
  );
}
